import { render, staticRenderFns } from "./RequestInquiry.vue?vue&type=template&id=fb2376e0&scoped=true&"
import script from "./RequestInquiry.vue?vue&type=script&lang=js&"
export * from "./RequestInquiry.vue?vue&type=script&lang=js&"
import style0 from "./RequestInquiry.vue?vue&type=style&index=0&id=fb2376e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb2376e0",
  null
  
)

export default component.exports